<!--新闻中心-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <div class="news-page-mode">
                <!--标题栏-->
                <div class="head-box">
                    <div class="sec-title">
                        <div class="bar"></div>
                        <div class="name">新闻资讯</div>
                    </div>
                    <div class="back-pill" @click="goHome">
                        <el-icon :size="16"><Back /></el-icon>
                        <span>返回</span>
                    </div>
                </div>
                <!--新闻列表-->
                <div class="achieve-list-container">
                    <div class="achieve-container" v-if="dataList&&dataList.length>0">
                        <div class="achieve-item-container" v-for="item in dataList" :key="item" @click="handleViewNews(item,'0')">
                            <div class="achieve-item" >
                                <div class="achieve-cover">
                                    <img :src="item.cover" alt />
                                </div>
                                <div class="achieve-title">{{item.title}}</div>
                                <div class="achieve-studio">{{item.groupName}}</div>
                            </div>
                        </div>

                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无新闻资讯"/>
                </div>
                <div class="page-container" v-if="dataList&&dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[8, 12, 16]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageAllNews" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {pageNews} from "@/api/admin/news";
export default {
    components: {
        pageTag, dataEmpty,
        homeHead,
    },
    name: "homeNewsCentre",
    data() {
        return {
            timestampToTime,
            activePath: "homeNewsCentre",
            queryParams: {
                pageNum: 1,
                pageSize: 8,
                newsType:'',
                status:1,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            newType:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageAllNews()
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        pageAllNews(){
            pageNews(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleViewNews(item,type){
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/hyedu/news",
                query: {
                    signno: item.newsId,
                    type:type
                }
            });
            window.open(routeUrl.href, '_blank')
        },
        /*返回首页*/
        goHome(){
            this.$router.push({path: '/hyedu/wel'});
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
.news-page-mode{
    width: 100%;
    max-width: 1840px;
    margin: 0 auto;
    height: calc(100vh - 140px);
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
/*标题栏*/
.head-box{
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}
.sec-title{
    display: flex;
    align-items: center;
    .bar{
        width: 4px;
        height: 16px;
        background: #0d55a4;
        border-radius: 2px;
        margin-right: 8px;
    }
    .name{
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }
}
.back-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 34px;
    padding: 0 18px;
    margin-left: auto;
    box-sizing: border-box;
    font-size: 14px;
    color: #fff;
    background: #29a8f0;
    border-radius: 17px;
    cursor: pointer;
}
/*新闻列表*/
.achieve-list-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
}
.achieve-container{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
.achieve-item-container{
    width: calc(25% - 12px);
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-item{
    width: 100%;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    padding: 10px;
    cursor: pointer;
    transition: box-shadow .2s;
}
.achieve-item:hover{
    box-shadow: 0 2px 12px rgba(13, 85, 164, .12);
}
.achieve-cover{
    width: 100%;
    height: 150px;
    border-radius: 8px;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.achieve-title{
    width: 100%;
    margin-top: 8px;
    font-size: 15px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333;
}
.achieve-studio{
    width: 100%;
    margin-top: 4px;
    color: #999;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*分页*/
.page-container{
    display: grid;
    place-items: center;
    width: 100%;
    height: 40px;
    flex-shrink: 0;
    padding-top: 10px;
    box-sizing: content-box;
}
</style>
